import userSelectors from '../selectors';
import userActions from '../actions';
import { useAppDispatch } from 'store/hooks';
import { useEffect } from 'react';

const useCountUnReadNoti = () => {
  const dispatch = useAppDispatch();
  const countUnreadNotifications = userSelectors.countUnreadNotifications();

  const mutate = () => {
    dispatch(userActions.countUnreadNotification.fetch());
  };

  useEffect(() => {
    mutate();
  }, []);

  return [countUnreadNotifications, mutate] as const;
};

export default useCountUnReadNoti;
